import { render, staticRenderFns } from "./Slide3.vue?vue&type=template&id=688b5577&scoped=true&"
import script from "./Slide3.vue?vue&type=script&lang=js&"
export * from "./Slide3.vue?vue&type=script&lang=js&"
import style0 from "./Slide3.vue?vue&type=style&index=0&id=688b5577&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b5577",
  null
  
)

export default component.exports